export interface AuthorizationCodeSettings {
  tokenUri: string;
  clientId: string;
  clientSecret: string;
  authUri: string;
  scope: string;
}

export interface ClientCredentialsSettings {
  tokenUri: string;
  clientId: string;
  clientSecret: string;
  audience: string;
  scope: string;
}

export interface EmailCredentialsSettings {
  tokenUri: string;
  email: string;
  password: string;
}

export interface JwtCertificateSettings {
  payloadAlgorithm: string;
  claims?: Record<string, string>;
}

export type ExternalAuthSettings =
  | AuthorizationCodeSettings
  | ClientCredentialsSettings
  | EmailCredentialsSettings
  | JwtCertificateSettings
  | Record<string, any>;

export interface ExternalAuthConfig {
  id?: string;
  name: string;
  grantTypeId: GrantType;
  settings: ExternalAuthSettings;
  status?: ExternalAuthStatus;
  hasCertificate?: boolean;
}

export const getDefaultExternalAuth = (): ExternalAuthConfig => ({
  name: '',
  grantTypeId: GrantType.AuthorizationCode,
  settings: {
    tokenUri: '',
    clientId: '',
    clientSecret: '',
    authUri: '',
    scope: '',
  },
});

export enum GrantType {
  AuthorizationCode = 1,
  ClientCredentials = 2,
  EmailCredentials = 3,
  JwtCertificate = 4,
}

export const GrantTypeNames: Record<GrantType, string> = {
  [GrantType.AuthorizationCode]: 'Authorization Code',
  [GrantType.ClientCredentials]: 'Client Credentials',
  [GrantType.EmailCredentials]: 'Email Credentials',
  [GrantType.JwtCertificate]: 'JWT Certificate',
};

export enum ExternalAuthStatus {
  Unknown = 'unknown',
  Valid = 'valid',
  Invalid = 'invalid',
  Expired = 'expired',
}
